import { Controller } from "stimulus";
import Highcharts, { chart } from "highcharts";

export default class extends Controller {
  static values = {
    chartType: String,
    chartData: Array,
    columnCategories: Array
  };

  connect() {
    console.log("Connected to chart controller");
    this.drawChart();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  drawChart() {
    let options = {};

    Highcharts.setOptions(options);

    let chartData;
    if (this.chartTypeValue === "pie") {
      chartData = this._pieChartOptions();
    } else if (this.chartTypeValue === "column") {
      chartData = this._columnChartOptions();
    }
    this.chart = Highcharts.chart(this.element.id, chartData);
  }

  _pieChartOptions() {
    return {
      chart: {
        type: "pie",
      },
      title: {
        text: "",
      },
      tooltip: {
        valueSuffix: "%",
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: [
            {
              enabled: true,
              distance: 20,
            },
            {
              enabled: true,
              distance: -40,
              format: "{point.percentage:.1f}%",
              style: {
                fontSize: "1.2em",
                textOutline: "none",
                opacity: 0.7,
              },
              filter: {
                operator: ">",
                property: "percentage",
                value: 10,
              },
            },
          ],
        },
      },
      series: [
        {
          name: "Percentage",
          colorByPoint: true,
          data: this.chartDataValue
        },
      ],
    }

  }

  _columnChartOptions() {
    console.log(this.columnCategoriesValue);
    return {
      chart: {
        type: "column",
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: this.columnCategoriesValue,
        crosshair: true,
        accessibility: {
          description: "Failure reasons",
        },
        plotLines: [{
          color: '#303030',
          value: -0.5,
          zIndex: 5
        }]
      },
      yAxis: {
        min: 0,
        title: {
          text: "Number of failures",
        },
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          color: "#3059a7"
        },
      },
      series: [
        {
          data: this.chartDataValue,
          name: "Failure reasons",
        }
      ],
    }
  }
}
